import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import AuthForm, { AuthTermsNote, type AuthStep } from "../components/AuthForm";
import PintoAuthShell from "../components/PintoAuthShell";
import useEnforceLightMode from "../hooks/useEnforceLightMode";
import { sanitizeAuthSource, sanitizeInternalReturnTo } from "../utils/authReturn";

export default function AuthPage() {
  useEnforceLightMode();
  const [searchParams] = useSearchParams();
  const returnTo = sanitizeInternalReturnTo(searchParams.get("returnTo"));
  const authSource = sanitizeAuthSource(searchParams.get("source"));
  const [step, setStep] = useState<AuthStep>("email");

  return (
    <PintoAuthShell minimal footer={step === "email" ? <AuthTermsNote /> : undefined}>
      <AuthForm returnTo={returnTo} authSource={authSource} onStepChange={setStep} />
    </PintoAuthShell>
  );
}
